var map = {
	"./alert_orange.svg": 67339,
	"./arrow-big.svg": 88062,
	"./arrow-down-s-white.svg": 70108,
	"./arrow-down-s.svg": 68364,
	"./arrow-green.svg": 46317,
	"./arrow-left.svg": 49039,
	"./arrow-new.svg": 77166,
	"./arrow-red.svg": 76545,
	"./bell.svg": 18603,
	"./check-mark.svg": 4094,
	"./coppy.svg": 10131,
	"./copy-bold.svg": 59833,
	"./copy-new.svg": 99490,
	"./copy.svg": 10927,
	"./countries/AD.svg": 24654,
	"./countries/AE.svg": 62591,
	"./countries/AF.svg": 83564,
	"./countries/AG.svg": 35373,
	"./countries/AI.svg": 98539,
	"./countries/AL.svg": 91974,
	"./countries/AM.svg": 54775,
	"./countries/AO.svg": 28197,
	"./countries/AQ.svg": 34979,
	"./countries/AR.svg": 68880,
	"./countries/AS.svg": 67329,
	"./countries/AT.svg": 7422,
	"./countries/AU.svg": 69999,
	"./countries/AW.svg": 19517,
	"./countries/AX.svg": 51242,
	"./countries/AZ.svg": 11848,
	"./countries/BA.svg": 7686,
	"./countries/BB.svg": 6821,
	"./countries/BD.svg": 14251,
	"./countries/BE.svg": 95194,
	"./countries/BF.svg": 10281,
	"./countries/BG.svg": 59064,
	"./countries/BH.svg": 61951,
	"./countries/BI.svg": 57198,
	"./countries/BJ.svg": 86317,
	"./countries/BL.svg": 90643,
	"./countries/BM.svg": 11650,
	"./countries/BN.svg": 66193,
	"./countries/BO.svg": 19744,
	"./countries/BQ.svg": 43894,
	"./countries/BR.svg": 1493,
	"./countries/BS.svg": 59508,
	"./countries/BT.svg": 8923,
	"./countries/BV.svg": 35481,
	"./countries/BW.svg": 27560,
	"./countries/BY.svg": 57758,
	"./countries/BZ.svg": 11933,
	"./countries/CA.svg": 74229,
	"./countries/CC.svg": 807,
	"./countries/CD.svg": 98408,
	"./countries/CF.svg": 45130,
	"./countries/CG.svg": 13947,
	"./countries/CH.svg": 11708,
	"./countries/CI.svg": 40253,
	"./countries/CK.svg": 14031,
	"./countries/CL.svg": 20240,
	"./countries/CM.svg": 11361,
	"./countries/CN.svg": 6322,
	"./countries/CO.svg": 9635,
	"./countries/CR.svg": 43334,
	"./countries/CU.svg": 12745,
	"./countries/CV.svg": 67930,
	"./countries/CW.svg": 61803,
	"./countries/CX.svg": 34924,
	"./countries/CY.svg": 82285,
	"./countries/CZ.svg": 99310,
	"./countries/DE.svg": 46628,
	"./countries/DJ.svg": 9907,
	"./countries/DK.svg": 6178,
	"./countries/DM.svg": 87340,
	"./countries/DO.svg": 51726,
	"./countries/DZ.svg": 62051,
	"./countries/EC.svg": 34557,
	"./countries/EE.svg": 15267,
	"./countries/EG.svg": 93761,
	"./countries/EH.svg": 82870,
	"./countries/ER.svg": 86700,
	"./countries/ES.svg": 85645,
	"./countries/ET.svg": 15426,
	"./countries/EU.svg": 20595,
	"./countries/FI.svg": 51386,
	"./countries/FJ.svg": 19497,
	"./countries/FK.svg": 15256,
	"./countries/FM.svg": 90054,
	"./countries/FO.svg": 61316,
	"./countries/FR.svg": 46177,
	"./countries/GA.svg": 24577,
	"./countries/GB.svg": 42834,
	"./countries/GD.svg": 64572,
	"./countries/GE.svg": 76765,
	"./countries/GF.svg": 64670,
	"./countries/GG.svg": 27247,
	"./countries/GH.svg": 69096,
	"./countries/GI.svg": 50841,
	"./countries/GL.svg": 35188,
	"./countries/GM.svg": 80117,
	"./countries/GN.svg": 67158,
	"./countries/GP.svg": 6816,
	"./countries/GQ.svg": 47377,
	"./countries/GR.svg": 66978,
	"./countries/GS.svg": 97555,
	"./countries/GT.svg": 40812,
	"./countries/GU.svg": 76269,
	"./countries/GW.svg": 19839,
	"./countries/GY.svg": 92457,
	"./countries/HK.svg": 70382,
	"./countries/HM.svg": 32928,
	"./countries/HN.svg": 53683,
	"./countries/HR.svg": 79783,
	"./countries/HT.svg": 72345,
	"./countries/HU.svg": 90600,
	"./countries/ID.svg": 47830,
	"./countries/IE.svg": 87367,
	"./countries/IL.svg": 45342,
	"./countries/IM.svg": 7919,
	"./countries/IN.svg": 45244,
	"./countries/IO.svg": 57437,
	"./countries/IQ.svg": 36459,
	"./countries/IR.svg": 97624,
	"./countries/IS.svg": 73129,
	"./countries/IT.svg": 29894,
	"./countries/JE.svg": 16418,
	"./countries/JM.svg": 83610,
	"./countries/JO.svg": 50040,
	"./countries/JP.svg": 60335,
	"./countries/KE.svg": 57025,
	"./countries/KG.svg": 6275,
	"./countries/KH.svg": 49844,
	"./countries/KI.svg": 91829,
	"./countries/KM.svg": 25817,
	"./countries/KN.svg": 65066,
	"./countries/KP.svg": 96940,
	"./countries/KR.svg": 47534,
	"./countries/KW.svg": 80979,
	"./countries/KY.svg": 97157,
	"./countries/KZ.svg": 98022,
	"./countries/LA.svg": 62496,
	"./countries/LB.svg": 33395,
	"./countries/LC.svg": 54402,
	"./countries/LI.svg": 1816,
	"./countries/LK.svg": 37946,
	"./countries/LR.svg": 58691,
	"./countries/LS.svg": 20754,
	"./countries/LT.svg": 54685,
	"./countries/LU.svg": 84060,
	"./countries/LV.svg": 63087,
	"./countries/LY.svg": 70312,
	"./countries/MA.svg": 91415,
	"./countries/MC.svg": 17861,
	"./countries/MD.svg": 10682,
	"./countries/ME.svg": 4555,
	"./countries/MF.svg": 46488,
	"./countries/MG.svg": 71849,
	"./countries/MH.svg": 42062,
	"./countries/MK.svg": 25037,
	"./countries/ML.svg": 96514,
	"./countries/MM.svg": 243,
	"./countries/MN.svg": 39232,
	"./countries/MO.svg": 53617,
	"./countries/MP.svg": 80342,
	"./countries/MQ.svg": 43559,
	"./countries/MR.svg": 95348,
	"./countries/MS.svg": 16981,
	"./countries/MT.svg": 87882,
	"./countries/MU.svg": 56699,
	"./countries/MV.svg": 41160,
	"./countries/MW.svg": 37177,
	"./countries/MX.svg": 36734,
	"./countries/MY.svg": 56783,
	"./countries/MZ.svg": 54460,
	"./countries/NA.svg": 38218,
	"./countries/NC.svg": 47848,
	"./countries/NE.svg": 73206,
	"./countries/NF.svg": 45077,
	"./countries/NG.svg": 88820,
	"./countries/NI.svg": 90962,
	"./countries/NL.svg": 14447,
	"./countries/NO.svg": 35420,
	"./countries/NP.svg": 3915,
	"./countries/NR.svg": 57417,
	"./countries/NU.svg": 27974,
	"./countries/NZ.svg": 26129,
	"./countries/OM.svg": 28397,
	"./countries/PA.svg": 25932,
	"./countries/PE.svg": 39072,
	"./countries/PF.svg": 9971,
	"./countries/PG.svg": 30978,
	"./countries/PH.svg": 26149,
	"./countries/PK.svg": 27014,
	"./countries/PL.svg": 29609,
	"./countries/PM.svg": 78392,
	"./countries/PN.svg": 33579,
	"./countries/PR.svg": 39663,
	"./countries/PS.svg": 77086,
	"./countries/PT.svg": 86017,
	"./countries/PW.svg": 97330,
	"./countries/PY.svg": 78836,
	"./countries/QA.svg": 28963,
	"./countries/RE.svg": 14794,
	"./countries/RO.svg": 25136,
	"./countries/RS.svg": 75812,
	"./countries/RU.svg": 65882,
	"./countries/RW.svg": 29752,
	"./countries/SA.svg": 79397,
	"./countries/SB.svg": 56966,
	"./countries/SC.svg": 71351,
	"./countries/SD.svg": 82168,
	"./countries/SE.svg": 86409,
	"./countries/SG.svg": 32907,
	"./countries/SH.svg": 6028,
	"./countries/SI.svg": 4973,
	"./countries/SJ.svg": 56622,
	"./countries/SK.svg": 85055,
	"./countries/SL.svg": 19168,
	"./countries/SM.svg": 55121,
	"./countries/SN.svg": 34754,
	"./countries/SO.svg": 39923,
	"./countries/SR.svg": 2198,
	"./countries/SS.svg": 66023,
	"./countries/ST.svg": 76840,
	"./countries/SV.svg": 67210,
	"./countries/SX.svg": 64412,
	"./countries/SY.svg": 53885,
	"./countries/SZ.svg": 99710,
	"./countries/TC.svg": 75402,
	"./countries/TD.svg": 47029,
	"./countries/TF.svg": 73607,
	"./countries/TG.svg": 34070,
	"./countries/TH.svg": 91489,
	"./countries/TJ.svg": 59139,
	"./countries/TK.svg": 9746,
	"./countries/TL.svg": 43677,
	"./countries/TM.svg": 31484,
	"./countries/TN.svg": 94159,
	"./countries/TO.svg": 31582,
	"./countries/TR.svg": 22699,
	"./countries/TT.svg": 52357,
	"./countries/TV.svg": 78935,
	"./countries/TW.svg": 16134,
	"./countries/TZ.svg": 86848,
	"./countries/UA.svg": 39167,
	"./countries/UG.svg": 66705,
	"./countries/UM.svg": 75115,
	"./countries/UN.svg": 36280,
	"./countries/US.svg": 96093,
	"./countries/UY.svg": 26023,
	"./countries/UZ.svg": 54516,
	"./countries/VA.svg": 54578,
	"./countries/VC.svg": 31024,
	"./countries/VE.svg": 34334,
	"./countries/VG.svg": 17884,
	"./countries/VI.svg": 51306,
	"./countries/VN.svg": 78069,
	"./countries/VU.svg": 33774,
	"./countries/WF.svg": 86190,
	"./countries/WS.svg": 44931,
	"./countries/XK.svg": 15006,
	"./countries/YE.svg": 88535,
	"./countries/YT.svg": 53558,
	"./countries/ZA.svg": 3646,
	"./countries/ZM.svg": 54794,
	"./countries/ZW.svg": 6144,
	"./cross-white.svg": 38320,
	"./cross.svg": 72992,
	"./currency/eur.svg": 89696,
	"./currency/uah.svg": 9190,
	"./currency/usd.svg": 58236,
	"./dataPicker.svg": 90894,
	"./devices/android.svg": 97473,
	"./devices/desktop.svg": 80196,
	"./devices/huawei.svg": 44171,
	"./devices/ios.svg": 66827,
	"./devices/mac-os.svg": 72352,
	"./devices/mobile.svg": 24874,
	"./devices/other-os.svg": 22873,
	"./devices/tablet.svg": 10932,
	"./devices/windows.svg": 18651,
	"./display.svg": 83650,
	"./download.svg": 13704,
	"./ellipsis.svg": 9465,
	"./error.svg": 44346,
	"./eye.svg": 64359,
	"./fav.svg": 78671,
	"./filter.svg": 75942,
	"./groupby.svg": 9570,
	"./header/arrow-left.svg": 37661,
	"./header/burger.svg": 13441,
	"./header/dashboard.svg": 9538,
	"./header/distribution.svg": 39356,
	"./header/landings.svg": 69138,
	"./header/marksel.svg": 71823,
	"./header/message.svg": 61583,
	"./header/offers.svg": 94547,
	"./header/payment.svg": 3428,
	"./header/products.svg": 59030,
	"./header/roles.svg": 72549,
	"./header/settings.svg": 45345,
	"./header/statistic.svg": 26024,
	"./info-big.svg": 44753,
	"./info-black.svg": 33950,
	"./info.svg": 30404,
	"./logo-m.svg": 24443,
	"./logo.svg": 55053,
	"./loop-white.svg": 43886,
	"./loupe.svg": 70953,
	"./minus.svg": 65248,
	"./pencil.svg": 14519,
	"./plus.svg": 23496,
	"./reload.svg": 88247,
	"./resize.svg": 77296,
	"./rubbish-gray.svg": 203,
	"./rubbish.svg": 13129,
	"./setting.svg": 81940,
	"./share.svg": 53697,
	"./skype.svg": 45258,
	"./sort.svg": 33284,
	"./switch-false.svg": 14038,
	"./switch-true.svg": 76197,
	"./telegram.svg": 99273,
	"./upload.svg": 21603,
	"./user.svg": 71129
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 95798;